import { Flex, Text } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate, useRouteError } from 'react-router-dom';
import { Button } from './components/ui/button';
import Content from './components/content';
import { api } from './lib/api';

export function ErrorPage() {
    const error = useRouteError() as Error & { status?: number };
    const navigate = useNavigate();

    useEffect(() => {
        if (error.status === 404) {
            navigate('/404');
        }
    }, [error.status, navigate]);

    useEffect(() => {
        async function logError() {
            await api.logging.logError({
                message: error.message,
                stack: error.stack,
                url: window.location.href,
                timestamp: new Date().toISOString(),
            });
        }

        if (error.status !== 404 && error.message) {
            logError();
        }
    }, [error]);

    if (error.status === 404) {
        return null;
    }

    return (
        <Content headerTitle="Something went wrong">
            {{
                content: (
                    <Flex
                        justifyContent="center"
                        alignItems="center"
                        h="100%"
                        w="100%"
                        flexDirection="column"
                        gap="16px"
                        textAlign="center">
                        <Text fontSize="24px" fontWeight="bold">
                            Something went wrong
                        </Text>
                        <Text fontSize="16px">We're sorry, but the app encountered an unexpected error</Text>
                        <Button colorScheme="teal" variant="solid" onClick={() => navigate('/')} size="md">
                            Go to Home Page
                        </Button>

                        {import.meta.env.DEV && error.message && (
                            <Flex mt="8" backgroundColor="white" borderRadius="md" padding="4" maxWidth="50%" overflow="auto">
                                <pre>{error.message}</pre>
                            </Flex>
                        )}
                    </Flex>
                ),
            }}
        </Content>
    );
}
